import React, { useState, useEffect } from 'react';
import { handleVideoPlayClick } from '../../../lib/customGA4';

const VideoSlide = ({
  YoutubeID,
  AuthorImage,
  AuthorName,
  AuthorTitle,
  PosterImage,
  EntryDate,
  SectionTItle
}) => {
  const formattedDate = new Date(EntryDate).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  const [videoSrc, setVideoSrc] = useState('');

  const handleModalClick = (src) => {
    handleVideoPlayClick(SectionTItle);
    setVideoSrc(src);

    const videoElement = document.getElementById('video-ex');
    videoElement.setAttribute('src', src);
  };

  useEffect(() => {
    const modal = document.getElementById('exampleModal');
    const videoElement = document.getElementById('video-ex');

    modal.addEventListener('hide.bs.modal', function () {
      videoElement.removeAttribute('src');
    });

    return () => {
      modal.removeEventListener('hide.bs.modal', function () {
        videoElement.removeAttribute('src');
      });
    };
  }, []);

  return (
    <div className="swiper-slide">
      <div className="hehts-slide-item">
        <div className="hehts-to-card">
          <div className="hehts-card-img">
            <picture>
              <source srcSet={PosterImage} type="image/webp" />
              <img
                className="hehts-card-img"
                src={PosterImage}
                alt="Hear What The Experts Have To Say"
                width="100%"
                height="560"
                loading="lazy"
              />
            </picture>
          </div>
          <div className="hehts-to-card-overlay">
            <div className="card-overlay-inner">
              <div className="overlay-flex-card">
                <div className="card-profile-img">
                  <picture>
                    <source srcSet={AuthorImage} type="image/webp" />
                    <img
                      className="hehts-card-name-img"
                      src={AuthorImage}
                      alt="Hear What The Experts Have To Say"
                      width="100%"
                      height="50"
                      loading="lazy"
                    />
                  </picture>
                </div>
                <div className="card-profile-information">
                  <div className="profile-text">
                    <span className="card-name-heading">{AuthorName}</span>
                    <p className="card-discription">{AuthorTitle}</p>
                    <div className={`card-date ${formattedDate === '1 Jan 1' ? 'd-none' : ''}`}>
                      {formattedDate}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="play-button">
            <a
              className="play-attribute video-play-button"
              href="#"
              data-src={`https://www.youtube.com/embed/${YoutubeID}`}
              onClick={() => handleModalClick(`https://www.youtube.com/embed/${YoutubeID}`)}
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15.256"
                height="17.051"
                viewBox="0 0 15.256 17.051"
              >
                <path
                  id="Polygon_12"
                  data-name="Polygon 12"
                  d="M7.653,1.562a1,1,0,0,1,1.746,0L16.22,13.769a1,1,0,0,1-.873,1.488H1.7a1,1,0,0,1-.873-1.488Z"
                  transform="translate(15.256) rotate(90)"
                  fill="#fff"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoSlide;
